const referralTypes = {
    GET_REFERRAL_ANALYTICS_PENDING: "GET_REFERRAL_ANALYTICS_PENDING",
    GET_REFERRAL_ANALYTICS_SUCCESS: "GET_REFERRAL_ANALYTICS_SUCCESS",
    GET_REFERRAL_ANALYTICS_ERROR: "GET_REFERRAL_ANALYTICS_ERROR",
}

export default referralTypes;
